export default {
  path: '/home',
  auth: false,
  preload: false,
  isStatic: true,
  key: 'home',
  component: () => import( /* webpackChunkName: "home" */'./index')
};
